(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["client-index"] && !Shopify.designMode) return;
  try {
    
(function(){
  var list=document.getElementById('ciList');
  if(!list) return;
  var items=[].slice.call(list.querySelectorAll('.ci-item'));
  function key(el){var l=el.querySelector('.ci-link');return ((l?l.textContent:el.textContent)||'').trim().toLowerCase();}
  items.sort(function(a,b){return key(a).localeCompare(key(b));});
  items.forEach(function(el){list.appendChild(el);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hospitality-banner"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    var bars=document.querySelectorAll('.fbn');
    if(!bars.length){ return; }
    Array.prototype.forEach.call(bars, function(el){
      var btn=el.querySelector('.fbn-close');
      if(!btn || btn.dataset.fbnBound){ return; }
      btn.dataset.fbnBound='1';
      btn.addEventListener('click', function(){
        el.style.display='none';
        if(el.getAttribute('data-persist')==='true' && window.localStorage){
          try{
            var k='fbn-dismissed-'+(el.getAttribute('data-key')||'');
            localStorage.setItem(k,'1');
          }catch(e){}
        }
      });
    });
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-index"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.wao');
  if(!root) return;
  var grid=root.querySelector('.wao-grid');
  var cards=grid?[].slice.call(grid.querySelectorAll('.card')):[];
  if(!cards.length) return;
  var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('reveal-on');
  if(reduce || !('IntersectionObserver' in window)){
    cards.forEach(function(c){c.classList.add('in');});
    return;
  }
  function colCount(){
    var t=getComputedStyle(grid).gridTemplateColumns;
    return t ? t.split(' ').length : 1;
  }
  var n=colCount();
  cards.forEach(function(c,i){ c.style.transitionDelay=((i % n)*0.07).toFixed(2)+'s'; });
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
    });
  },{rootMargin:'0px 0px -10% 0px', threshold:0.05});
  cards.forEach(function(c){ io.observe(c); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-project-rail"] && !Shopify.designMode) return;
  try {
    
(function(){
  var wp=document.querySelector('.wpr');
  if(wp) wp.classList.add('has-js');
  var lb=document.getElementById('wpLb');
  var thumbs=[].slice.call(document.querySelectorAll('.wp-gallery img[data-full]'));
  if(lb && thumbs.length){
    var full=thumbs.map(function(t){return t.getAttribute('data-full');});
    var small=thumbs.map(function(t){return t.getAttribute('src');});
    var alts=thumbs.map(function(t){return t.getAttribute('alt')||'';});
    var imgEl=lb.querySelector('.wp-lb-img');
    var pPrev=lb.querySelector('.wp-lb-pprev');
    var pNext=lb.querySelector('.wp-lb-pnext');
    var countEl=lb.querySelector('.wp-lb-count');
    var stageEl=lb.querySelector('.wp-lb-stage');
    var strip=lb.querySelector('.wp-lb-strip');
    var single=full.length<2;
    if(single) lb.classList.add('wp-lb-single');
    var thumbEls=[];
    if(!single){
      full.forEach(function(u,n){
        var t=document.createElement('img');
        t.src=small[n]; t.alt=''; t.className='wp-lb-thumb'; t.setAttribute('aria-label','Go to image '+(n+1));
        t.addEventListener('click',function(){i=n;show();});
        strip.appendChild(t); thumbEls.push(t);
      });
    }
    var i=0;
    function show(){
      imgEl.src=full[i]; imgEl.alt=alts[i];
      countEl.textContent=(i+1)+' / '+full.length;
      if(!single){
        pPrev.src=full[(i-1+full.length)%full.length];
        pNext.src=full[(i+1)%full.length];
        thumbEls.forEach(function(t,n){t.classList.toggle('active',n===i);});
        if(thumbEls[i] && thumbEls[i].scrollIntoView) thumbEls[i].scrollIntoView({inline:'center',block:'nearest'});
      }
    }
    function open(n){i=n;show();lb.hidden=false;document.documentElement.style.overflow='hidden';}
    function close(){lb.hidden=true;document.documentElement.style.overflow='';}
    function next(){i=(i+1)%full.length;show();}
    function prev(){i=(i-1+full.length)%full.length;show();}
    thumbs.forEach(function(t,n){t.addEventListener('click',function(){open(n);});});
    lb.querySelector('.wp-lb-close').addEventListener('click',close);
    lb.querySelector('.wp-lb-next').addEventListener('click',next);
    lb.querySelector('.wp-lb-prev').addEventListener('click',prev);

    var down=false,startX=0,dx=0,moved=false;
    function dragStart(e){
      if(single)return;
      down=true;moved=false;dx=0;
      startX=(e.touches?e.touches[0].clientX:e.clientX);
      imgEl.style.transition='none';
      stageEl.classList.add('dragging');
    }
    function dragMove(e){
      if(!down)return;
      var x=(e.touches?e.touches[0].clientX:e.clientX);
      dx=x-startX;
      if(Math.abs(dx)>6)moved=true;
      imgEl.style.transform='translateX('+dx+'px)';
    }
    function dragEnd(){
      if(!down)return;
      down=false;
      stageEl.classList.remove('dragging');
      imgEl.style.transition='transform .2s ease';
      var th=Math.min(120, stageEl.offsetWidth*0.12);
      if(dx<=-th) next();
      else if(dx>=th) prev();
      imgEl.style.transform='';
    }
    stageEl.addEventListener('pointerdown',dragStart);
    stageEl.addEventListener('pointermove',dragMove);
    stageEl.addEventListener('pointerup',dragEnd);
    stageEl.addEventListener('pointercancel',dragEnd);
    stageEl.addEventListener('pointerleave',dragEnd);

    pPrev.addEventListener('click',function(){if(moved){moved=false;return;}prev();});
    pNext.addEventListener('click',function(){if(moved){moved=false;return;}next();});
    lb.addEventListener('click',function(e){
      if(moved){moved=false;return;}
      if(e.target===lb||e.target===stageEl)close();
    });
    document.addEventListener('keydown',function(e){
      if(lb.hidden)return;
      if(e.key==='Escape')close();
      else if(e.key==='ArrowRight')next();
      else if(e.key==='ArrowLeft')prev();
    });
  }
  var reveal=[].slice.call(document.querySelectorAll('.wp-item'));
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});},{rootMargin:'0px 0px -8% 0px'});
    reveal.forEach(function(el){io.observe(el);});
  } else {
    reveal.forEach(function(el){el.classList.add('in');});
  }

  /* scroll-jacked horizontal More-projects */
  (function(){
    var sec=document.querySelector('.wp-hsx');
    var pin=sec && sec.querySelector('.wp-hsx-pin');
    var track=document.getElementById('wpHsxTrack');
    if(!sec||!pin||!track) return;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var coarse=window.matchMedia&&window.matchMedia('(pointer: coarse)').matches;
    /* on touch or reduced-motion, use a plain horizontal scroll strip */
    if(reduce||coarse){ sec.classList.add('is-fallback'); return; }

    var startX=0, endX=0, total=0;
    function measure(){
      var vw=pin.clientWidth;
      var tw=track.scrollWidth;
      /* first card starts ~1/3 in from the left, then scrolls left */
      startX=Math.round(vw*0.32);
      /* end when the row's tail (incl. View all) reaches the right edge */
      endX=Math.min(0, vw - tw - 24);
      total=Math.max(1, startX - endX);
      sec.style.height=(window.innerHeight + total)+'px';
    }
    function onScroll(){
      var rect=sec.getBoundingClientRect();
      var start=-rect.top;
      var t=Math.min(1, Math.max(0, start/(total||1)));
      var x=startX + (endX - startX)*t;
      track.style.transform='translate3d('+x+'px,0,0)';
    }
    measure();
    onScroll();
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', function(){ measure(); onScroll(); });
    /* re-measure once images load (widths can shift) */
    [].slice.call(track.querySelectorAll('img')).forEach(function(img){
      if(!img.complete){ img.addEventListener('load', function(){ measure(); onScroll(); }, {once:true}); }
    });
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-project-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStory(root) {
    if (!root || root.dataset.cmxvReady === '1') return;
    root.dataset.cmxvReady = '1';

    var lb = root.querySelector('[data-cmxv-lb]');
    var lbImg = root.querySelector('[data-cmxv-lbimg]');
    var closeBtn = root.querySelector('[data-cmxv-close]');
    var items = root.querySelectorAll('[data-cmxv-full]');

    function open(src) {
      if (!lb || !lbImg || !src) return;
      lbImg.setAttribute('src', src);
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      if (!lb || !lbImg) return;
      lb.hidden = true;
      lbImg.setAttribute('src', '');
      document.documentElement.style.overflow = '';
    }

    for (var i = 0; i < items.length; i++) {
      (function (el) {
        el.addEventListener('click', function () {
          open(el.getAttribute('data-cmxv-full'));
        });
      })(items[i]);
    }

    if (lb) {
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target === closeBtn) close();
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    var vid = root.querySelector('video.cmxv-video__el');
    if (vid && vid.hasAttribute('autoplay')) {
      vid.muted = true;
      var p = vid.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () { vid.setAttribute('controls', 'controls'); });
      }
    }

    var soundBtn = root.querySelector('[data-cmxv-sound]');
    var soundTxt = root.querySelector('[data-cmxv-soundtxt]');
    if (soundBtn && vid) {
      soundBtn.addEventListener('click', function () {
        var on = vid.muted;
        vid.muted = !on;
        if (on && vid.paused) {
          var r = vid.play();
          if (r && typeof r.catch === 'function') { r.catch(function () {}); }
        }
        soundBtn.classList.toggle('is-on', on);
        soundBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (soundTxt) soundTxt.textContent = on ? 'Sound on' : 'Sound off';
      });
    }
  }

  function boot() {
    var nodes = document.querySelectorAll('.cmxv');
    for (var i = 0; i < nodes.length; i++) initStory(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('.cmxv') : null;
    if (el) initStory(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-project-video"] && !Shopify.designMode) return;
  try {
    
(function(){
  var wpv=document.querySelector('.wpv');
  if(wpv) wpv.classList.add('has-js');
  var vid=document.querySelector('.wpv-media video');
  if(vid){ vid.muted=true; vid.setAttribute('muted',''); vid.playsInline=true; var pp=vid.play(); if(pp&&pp.catch){pp.catch(function(){});} }
  var lb=document.getElementById('wpvLb');
  var thumbs=[].slice.call(document.querySelectorAll('.wpv-strip img[data-full]'));
  if(lb && thumbs.length){
    var full=thumbs.map(function(t){return t.getAttribute('data-full');});
    var small=thumbs.map(function(t){return t.getAttribute('src');});
    var alts=thumbs.map(function(t){return t.getAttribute('alt')||'';});
    var imgEl=lb.querySelector('.wp-lb-img');
    var pPrev=lb.querySelector('.wp-lb-pprev');
    var pNext=lb.querySelector('.wp-lb-pnext');
    var countEl=lb.querySelector('.wp-lb-count');
    var stageEl=lb.querySelector('.wp-lb-stage');
    var strip=lb.querySelector('.wp-lb-strip');
    var single=full.length<2;
    if(single) lb.classList.add('wp-lb-single');
    var thumbEls=[];
    if(!single){
      full.forEach(function(u,n){
        var t=document.createElement('img');
        t.src=small[n]; t.alt=''; t.className='wp-lb-thumb'; t.setAttribute('aria-label','Go to image '+(n+1));
        t.addEventListener('click',function(){i=n;show();});
        strip.appendChild(t); thumbEls.push(t);
      });
    }
    var i=0;
    function show(){
      imgEl.src=full[i]; imgEl.alt=alts[i];
      countEl.textContent=(i+1)+' / '+full.length;
      if(!single){
        pPrev.src=full[(i-1+full.length)%full.length];
        pNext.src=full[(i+1)%full.length];
        thumbEls.forEach(function(t,n){t.classList.toggle('active',n===i);});
        if(thumbEls[i] && thumbEls[i].scrollIntoView) thumbEls[i].scrollIntoView({inline:'center',block:'nearest'});
      }
    }
    function open(n){i=n;show();lb.hidden=false;document.documentElement.style.overflow='hidden';}
    function close(){lb.hidden=true;document.documentElement.style.overflow='';}
    function next(){i=(i+1)%full.length;show();}
    function prev(){i=(i-1+full.length)%full.length;show();}
    thumbs.forEach(function(t,n){t.addEventListener('click',function(){open(n);});});
    lb.querySelector('.wp-lb-close').addEventListener('click',close);
    lb.querySelector('.wp-lb-next').addEventListener('click',next);
    lb.querySelector('.wp-lb-prev').addEventListener('click',prev);
    var down=false,startX=0,dx=0,moved=false;
    function dragStart(e){
      if(single)return;
      down=true;moved=false;dx=0;
      startX=(e.touches?e.touches[0].clientX:e.clientX);
      imgEl.style.transition='none';
      stageEl.classList.add('dragging');
    }
    function dragMove(e){
      if(!down)return;
      var x=(e.touches?e.touches[0].clientX:e.clientX);
      dx=x-startX;
      if(Math.abs(dx)>6)moved=true;
      imgEl.style.transform='translateX('+dx+'px)';
    }
    function dragEnd(){
      if(!down)return;
      down=false;
      stageEl.classList.remove('dragging');
      imgEl.style.transition='transform .2s ease';
      var th=Math.min(120, stageEl.offsetWidth*0.12);
      if(dx<=-th) next();
      else if(dx>=th) prev();
      imgEl.style.transform='';
    }
    stageEl.addEventListener('pointerdown',dragStart);
    stageEl.addEventListener('pointermove',dragMove);
    stageEl.addEventListener('pointerup',dragEnd);
    stageEl.addEventListener('pointercancel',dragEnd);
    stageEl.addEventListener('pointerleave',dragEnd);
    pPrev.addEventListener('click',function(){if(moved){moved=false;return;}prev();});
    pNext.addEventListener('click',function(){if(moved){moved=false;return;}next();});
    lb.addEventListener('click',function(e){
      if(moved){moved=false;return;}
      if(e.target===lb||e.target===stageEl)close();
    });
    document.addEventListener('keydown',function(e){
      if(lb.hidden)return;
      if(e.key==='Escape')close();
      else if(e.key==='ArrowRight')next();
      else if(e.key==='ArrowLeft')prev();
    });
  }
  var reveal=[].slice.call(document.querySelectorAll('.wpv-shot'));
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});},{rootMargin:'0px 0px -8% 0px'});
    reveal.forEach(function(el){io.observe(el);});
  } else {
    reveal.forEach(function(el){el.classList.add('in');});
  }

  /* scroll-jacked horizontal More-projects */
  (function(){
    var sec=document.querySelector('.wp-hsx');
    var pin=sec && sec.querySelector('.wp-hsx-pin');
    var track=document.getElementById('wpHsxTrack');
    if(!sec||!pin||!track) return;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var coarse=window.matchMedia&&window.matchMedia('(pointer: coarse)').matches;
    if(reduce||coarse){ sec.classList.add('is-fallback'); return; }
    var startX=0, endX=0, total=0;
    function measure(){
      var vw=pin.clientWidth;
      var tw=track.scrollWidth;
      /* first card starts ~1/3 in from the left, then scrolls left */
      startX=Math.round(vw*0.32);
      /* end when the row's tail (incl. View all) reaches the right edge */
      endX=Math.min(0, vw - tw - 24);
      total=Math.max(1, startX - endX);
      sec.style.height=(window.innerHeight + total)+'px';
    }
    function onScroll(){
      var rect=sec.getBoundingClientRect();
      var start=-rect.top;
      var t=Math.min(1, Math.max(0, start/(total||1)));
      var x=startX + (endX - startX)*t;
      track.style.transform='translate3d('+x+'px,0,0)';
    }
    measure(); onScroll();
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', function(){ measure(); onScroll(); });
    [].slice.call(track.querySelectorAll('img')).forEach(function(img){
      if(!img.complete){ img.addEventListener('load', function(){ measure(); onScroll(); }, {once:true}); }
    });
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-project"] && !Shopify.designMode) return;
  try {
    
(function(){
  var wp=document.querySelector('.wp');
  if(wp) wp.classList.add('has-js');
  var lb=document.getElementById('wpLb');
  var thumbs=[].slice.call(document.querySelectorAll('.wp-gallery img[data-full]'));
  if(lb && thumbs.length){
    var full=thumbs.map(function(t){return t.getAttribute('data-full');});
    var small=thumbs.map(function(t){return t.getAttribute('src');});
    var alts=thumbs.map(function(t){return t.getAttribute('alt')||'';});
    var imgEl=lb.querySelector('.wp-lb-img');
    var pPrev=lb.querySelector('.wp-lb-pprev');
    var pNext=lb.querySelector('.wp-lb-pnext');
    var countEl=lb.querySelector('.wp-lb-count');
    var stageEl=lb.querySelector('.wp-lb-stage');
    var strip=lb.querySelector('.wp-lb-strip');
    var single=full.length<2;
    if(single) lb.classList.add('wp-lb-single');
    var thumbEls=[];
    if(!single){
      full.forEach(function(u,n){
        var t=document.createElement('img');
        t.src=small[n]; t.alt=''; t.className='wp-lb-thumb'; t.setAttribute('aria-label','Go to image '+(n+1));
        t.addEventListener('click',function(){i=n;show();});
        strip.appendChild(t); thumbEls.push(t);
      });
    }
    var i=0;
    function show(){
      imgEl.src=full[i]; imgEl.alt=alts[i];
      countEl.textContent=(i+1)+' / '+full.length;
      if(!single){
        pPrev.src=full[(i-1+full.length)%full.length];
        pNext.src=full[(i+1)%full.length];
        thumbEls.forEach(function(t,n){t.classList.toggle('active',n===i);});
        if(thumbEls[i] && thumbEls[i].scrollIntoView) thumbEls[i].scrollIntoView({inline:'center',block:'nearest'});
      }
    }
    function open(n){i=n;show();lb.hidden=false;document.documentElement.style.overflow='hidden';}
    function close(){lb.hidden=true;document.documentElement.style.overflow='';}
    function next(){i=(i+1)%full.length;show();}
    function prev(){i=(i-1+full.length)%full.length;show();}
    thumbs.forEach(function(t,n){t.addEventListener('click',function(){open(n);});});
    lb.querySelector('.wp-lb-close').addEventListener('click',close);
    lb.querySelector('.wp-lb-next').addEventListener('click',next);
    lb.querySelector('.wp-lb-prev').addEventListener('click',prev);

    var down=false,startX=0,dx=0,moved=false;
    function dragStart(e){
      if(single)return;
      down=true;moved=false;dx=0;
      startX=(e.touches?e.touches[0].clientX:e.clientX);
      imgEl.style.transition='none';
      stageEl.classList.add('dragging');
    }
    function dragMove(e){
      if(!down)return;
      var x=(e.touches?e.touches[0].clientX:e.clientX);
      dx=x-startX;
      if(Math.abs(dx)>6)moved=true;
      imgEl.style.transform='translateX('+dx+'px)';
    }
    function dragEnd(){
      if(!down)return;
      down=false;
      stageEl.classList.remove('dragging');
      imgEl.style.transition='transform .2s ease';
      var th=Math.min(120, stageEl.offsetWidth*0.12);
      if(dx<=-th) next();
      else if(dx>=th) prev();
      imgEl.style.transform='';
    }
    stageEl.addEventListener('pointerdown',dragStart);
    stageEl.addEventListener('pointermove',dragMove);
    stageEl.addEventListener('pointerup',dragEnd);
    stageEl.addEventListener('pointercancel',dragEnd);
    stageEl.addEventListener('pointerleave',dragEnd);

    pPrev.addEventListener('click',function(){if(moved){moved=false;return;}prev();});
    pNext.addEventListener('click',function(){if(moved){moved=false;return;}next();});
    lb.addEventListener('click',function(e){
      if(moved){moved=false;return;}
      if(e.target===lb||e.target===stageEl)close();
    });
    document.addEventListener('keydown',function(e){
      if(lb.hidden)return;
      if(e.key==='Escape')close();
      else if(e.key==='ArrowRight')next();
      else if(e.key==='ArrowLeft')prev();
    });
  }
  var reveal=[].slice.call(document.querySelectorAll('.wp-item, .wp-more-card'));
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});},{rootMargin:'0px 0px -8% 0px'});
    reveal.forEach(function(el){io.observe(el);});
  } else {
    reveal.forEach(function(el){el.classList.add('in');});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-showcase"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    var root=document.querySelector('.stk');
    if(!root) return;
    var intro=root.querySelector('.stk-intro');
    var grid=root.querySelector('.stk-grid-wrap');
    var cont=root.querySelector('.stk-continue');

    /* split the intro paragraph into visual lines so each cascades in one
       at a time. Group words by their offsetTop (a new top = a new line). */
    var body=root.querySelector('.stk-body');
    var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var smallScreen=window.matchMedia && window.matchMedia('(max-width: 900px)').matches;
    if(body && !reduce && !smallScreen){
      try{
        var paras=[].slice.call(body.querySelectorAll('p'));
        if(!paras.length){ paras=[body]; }
        var lineIndex=0;
        paras.forEach(function(p){
          var words=(p.textContent||'').trim().split(/\s+/);
          if(words.length===1 && words[0]===''){ return; }
          p.textContent='';
          var wordSpans=words.map(function(w){
            var s=document.createElement('span');
            s.textContent=w;
            s.style.display='inline-block';
            p.appendChild(s);
            p.appendChild(document.createTextNode(' '));
            return s;
          });
          /* group consecutive words sharing an offsetTop into a line span */
          var lines=[], cur=[], top=null;
          wordSpans.forEach(function(s){
            var t=s.offsetTop;
            if(top===null||t===top){ cur.push(s); }
            else { lines.push(cur); cur=[s]; }
            top=t;
          });
          if(cur.length){ lines.push(cur); }
          p.textContent='';
          lines.forEach(function(group){
            var line=document.createElement('span');
            line.className='stk-line';
            line.style.setProperty('--i', lineIndex++);
            line.textContent=group.map(function(s){return s.textContent;}).join(' ');
            p.appendChild(line);
            p.appendChild(document.createTextNode(' '));
          });
        });
        if(lineIndex>0){
          body.classList.add('is-split');
          /* trigger the cascade on the next frame so the hidden->visible
             animation actually plays; if this never runs, lines stay visible */
          requestAnimationFrame(function(){
            requestAnimationFrame(function(){ body.classList.add('play'); });
          });
        }
      }catch(err){ /* leave body as-is; block fade still works */ }
    }

    /* fade the intro out as you scroll the first screen (only ever lowers
       opacity once scrolled; text is full opacity at rest) */
    function onScroll(){
      var y=window.pageYOffset || document.documentElement.scrollTop || 0;
      var vh=window.innerHeight || 1;
      var t=Math.min(1, Math.max(0, y/(vh*0.85)));
      if(intro){ intro.style.setProperty('--stk-fade', (1-t).toFixed(3)); }
    }
    onScroll();
    window.addEventListener('scroll', onScroll, {passive:true});

    /* Continue button scrolls to the grid */
    if(cont && grid){
      cont.addEventListener('click', function(){
        var top=grid.getBoundingClientRect().top + (window.pageYOffset||0);
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    }

    /* cards waterfall in as they enter the viewport (same cascade feel as
       the intro). reveal-on is added by JS so no-JS users see cards normally. */
    var gridEl=root.querySelector('.stk-grid');
    var cards=gridEl ? [].slice.call(gridEl.querySelectorAll('.stk-card')) : [];
    if(gridEl && cards.length && !reduce && 'IntersectionObserver' in window){
      gridEl.classList.add('reveal-on');
      var cio=new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){
            var el=en.target;
            /* stagger by column position so each row cascades left-to-right */
            var sibs=[].slice.call(el.parentNode.children);
            var idx=sibs.indexOf(el);
            var cols=getComputedStyle(el.parentNode).gridTemplateColumns.split(' ').length || 1;
            var col=idx % cols;
            el.style.transitionDelay=(col*0.1)+'s';
            el.classList.add('in');
            cio.unobserve(el);
          }
        });
      },{rootMargin:'0px 0px -10% 0px'});
      cards.forEach(function(c){ cio.observe(c); });
    }

    /* video cards: hover-to-play on desktop only. Sources load lazily
       (preload=none + data-src) so a grid of videos stays light. */
    var vids=root.querySelectorAll('.stk-vid');
    if(vids.length){
      var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

      function load(v){
        if(v.dataset.src && !v.src){ v.src=v.dataset.src; }
      }
      function play(v){
        load(v);
        var p=v.play();
        if(p && p.catch){ p.catch(function(){}); }
        v.classList.add('is-playing');
      }
      function stop(v){
        v.classList.remove('is-playing');
        try{ v.pause(); }catch(e){}
      }

      /* desktop: play on hover. On touch there is no autoplay any more -
         the video stays hidden and the mobile reveal below provides the cue. */
      if(canHover){
        Array.prototype.forEach.call(vids, function(v){
          var card=v.closest('.stk-card');
          if(!card) return;
          card.addEventListener('mouseenter', function(){ play(v); });
          card.addEventListener('mouseleave', function(){ stop(v); v.currentTime=0; });
        });
      }
    }

    /* mobile reveal: replaces the autoplay video. As a card scrolls into view
       it desaturates and its caption (name, location, and a "View project"
       arrow) slides up - signalling the card is tappable. Enabled whenever
       IntersectionObserver exists; the reveal visuals are scoped to <=900px in
       CSS, so desktop is unaffected and the editor's mobile preview shows it.
       The .stk-reveal-mode class is only added when this runs, so no-JS / no-IO
       users keep the caption in normal flow below the image. */
    if(gridEl && cards.length && 'IntersectionObserver' in window){
      gridEl.classList.add('stk-reveal-mode');
      var rio=new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.intersectionRatio>=0.6){ en.target.classList.add('is-open'); }
          else { en.target.classList.remove('is-open'); }
        });
      },{threshold:[0,0.6,1]});
      cards.forEach(function(c){ rio.observe(c); });
    }
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-slideshow-hp"] && !Shopify.designMode) return;
  try {
    
(function(){
  var GSAP='https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  var ST='https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
  var loading=null;

  function loadScript(src){
    return new Promise(function(resolve,reject){
      var s=document.createElement('script');
      s.src=src; s.async=true; s.onload=resolve; s.onerror=reject;
      document.head.appendChild(s);
    });
  }
  function ensureGsap(){
    if(window.gsap && window.ScrollTrigger){ return Promise.resolve(); }
    if(loading){ return loading; }
    loading=loadScript(GSAP).then(function(){ return loadScript(ST); });
    return loading;
  }

  function videoHover(root){
    var canHover=window.matchMedia && window.matchMedia('(hover: hover)').matches;
    var vids=root.querySelectorAll('.ghs-vid');
    if(!canHover || !vids.length){ return; }
    Array.prototype.forEach.call(vids, function(v){
      var card=v.closest('.ghs-card');
      if(!card){ return; }
      card.addEventListener('mouseenter', function(){
        if(v.dataset.src && !v.src){ v.src=v.dataset.src; }
        var p=v.play(); if(p && p.catch){ p.catch(function(){}); }
        v.classList.add('is-playing');
      });
      card.addEventListener('mouseleave', function(){
        v.classList.remove('is-playing');
        try{ v.pause(); v.currentTime=0; }catch(e){}
      });
    });
  }

  function pin(root){
    var track=root.querySelector('.ghs-track');
    if(!track){ return; }
    ensureGsap().then(function(){
      if(!window.gsap || !window.ScrollTrigger){ return; }
      window.gsap.registerPlugin(window.ScrollTrigger);
      root.classList.add('is-pinned');
      var amount=function(){ return Math.max(0, track.scrollWidth - window.innerWidth); };
      var drift=window.gsap.to(track, { x:function(){ return -amount(); }, ease:'none' });
      window.ScrollTrigger.create({
        trigger: root,
        start: 'top top',
        end: function(){ return '+=' + amount(); },
        pin: true,
        scrub: 1,
        anticipatePin: 1,
        animation: drift,
        invalidateOnRefresh: true
      });
      window.addEventListener('load', function(){ window.ScrollTrigger.refresh(); });
    }).catch(function(){ /* GSAP blocked: stays a swipe rail */ });
  }

  function setup(root){
    if(root.dataset.ghsInit){ return; }
    root.dataset.ghsInit='1';
    videoHover(root);
    var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var small=window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    var editor=window.Shopify && window.Shopify.designMode;
    if(reduce || small || editor){ return; } /* swipe rail; pin runs live on desktop */
    pin(root);
  }

  function initAll(scope){
    var roots=(scope||document).querySelectorAll('.ghs');
    Array.prototype.forEach.call(roots, setup);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-stack"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    var root=document.querySelector('.stk');
    if(!root) return;
    var intro=root.querySelector('.stk-intro');
    var grid=root.querySelector('.stk-grid-wrap');
    var cont=root.querySelector('.stk-continue');

    /* split the intro paragraph into visual lines so each cascades in one
       at a time. Group words by their offsetTop (a new top = a new line). */
    var body=root.querySelector('.stk-body');
    var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(body && !reduce){
      try{
        var paras=[].slice.call(body.querySelectorAll('p'));
        if(!paras.length){ paras=[body]; }
        var lineIndex=0;
        paras.forEach(function(p){
          var words=(p.textContent||'').trim().split(/\s+/);
          if(words.length===1 && words[0]===''){ return; }
          p.textContent='';
          var wordSpans=words.map(function(w){
            var s=document.createElement('span');
            s.textContent=w;
            s.style.display='inline-block';
            p.appendChild(s);
            p.appendChild(document.createTextNode(' '));
            return s;
          });
          /* group consecutive words sharing an offsetTop into a line span */
          var lines=[], cur=[], top=null;
          wordSpans.forEach(function(s){
            var t=s.offsetTop;
            if(top===null||t===top){ cur.push(s); }
            else { lines.push(cur); cur=[s]; }
            top=t;
          });
          if(cur.length){ lines.push(cur); }
          p.textContent='';
          lines.forEach(function(group){
            var line=document.createElement('span');
            line.className='stk-line';
            line.style.setProperty('--i', lineIndex++);
            line.textContent=group.map(function(s){return s.textContent;}).join(' ');
            p.appendChild(line);
          });
        });
        if(lineIndex>0){
          body.classList.add('is-split');
          /* trigger the cascade on the next frame so the hidden->visible
             animation actually plays; if this never runs, lines stay visible */
          requestAnimationFrame(function(){
            requestAnimationFrame(function(){ body.classList.add('play'); });
          });
        }
      }catch(err){ /* leave body as-is; block fade still works */ }
    }

    /* fade the intro out as you scroll the first screen (only ever lowers
       opacity once scrolled; text is full opacity at rest) */
    function onScroll(){
      var y=window.pageYOffset || document.documentElement.scrollTop || 0;
      var vh=window.innerHeight || 1;
      var t=Math.min(1, Math.max(0, y/(vh*0.85)));
      if(intro){ intro.style.setProperty('--stk-fade', (1-t).toFixed(3)); }
    }
    onScroll();
    window.addEventListener('scroll', onScroll, {passive:true});

    /* Continue button scrolls to the grid */
    if(cont && grid){
      cont.addEventListener('click', function(){
        var top=grid.getBoundingClientRect().top + (window.pageYOffset||0);
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    }

    /* cards waterfall in as they enter the viewport (same cascade feel as
       the intro). reveal-on is added by JS so no-JS users see cards normally. */
    var gridEl=root.querySelector('.stk-grid');
    var cards=gridEl ? [].slice.call(gridEl.querySelectorAll('.stk-card')) : [];
    if(gridEl && cards.length && !reduce && 'IntersectionObserver' in window){
      gridEl.classList.add('reveal-on');
      var cio=new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){
            var el=en.target;
            /* stagger by column position so each row cascades left-to-right */
            var sibs=[].slice.call(el.parentNode.children);
            var idx=sibs.indexOf(el);
            var cols=getComputedStyle(el.parentNode).gridTemplateColumns.split(' ').length || 1;
            var col=idx % cols;
            el.style.transitionDelay=(col*0.08)+'s';
            el.classList.add('in');
            cio.unobserve(el);
          }
        });
      },{rootMargin:'0px 0px -10% 0px'});
      cards.forEach(function(c){ cio.observe(c); });
    }

    /* video cards: hover-to-play on desktop, autoplay-in-view on touch.
       sources load lazily (preload=none + data-src) so a grid of videos
       stays light. */
    var vids=root.querySelectorAll('.stk-vid');
    if(vids.length){
      var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

      function load(v){
        if(v.dataset.src && !v.src){ v.src=v.dataset.src; }
      }
      function play(v){
        load(v);
        var p=v.play();
        if(p && p.catch){ p.catch(function(){}); }
        v.classList.add('is-playing');
      }
      function stop(v){
        v.classList.remove('is-playing');
        try{ v.pause(); }catch(e){}
      }

      if(canHover){
        Array.prototype.forEach.call(vids, function(v){
          var card=v.closest('.stk-card');
          if(!card) return;
          card.addEventListener('mouseenter', function(){ play(v); });
          card.addEventListener('mouseleave', function(){ stop(v); v.currentTime=0; });
        });
      } else if('IntersectionObserver' in window){
        var io=new IntersectionObserver(function(entries){
          entries.forEach(function(en){
            var v=en.target;
            if(en.isIntersecting && en.intersectionRatio>=0.6){ play(v); }
            else { stop(v); }
          });
        }, { threshold:[0,0.6] });
        Array.prototype.forEach.call(vids, function(v){ io.observe(v); });
      }
    }
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
